export default __webpack_public_path__ + "static/media/raspored-fade-half.b6b6c726.png";